import React from 'react';
import { useTranslation } from 'react-i18next';
import './BookingBridgeStrip.css';

const BOOKING_HOME = 'https://www.rintintin-booking.com';
const LP = 'landingV2';

type Props = {
  /** Hub métier Booking optionnel (ex. /services/educateur-canin). */
  hubHref?: string;
  hubLabel?: string;
  /** Une ligne : titre + bouton, sans surtitre ni paragraphe (page tarifs). */
  compact?: boolean;
};

/**
 * Pont Pro → Booking (#793) — sans inventer de commission %.
 * Rintintin Pro = logiciel ; Booking = découverte / réservation côté propriétaires.
 */
export default function BookingBridgeStrip({
  hubHref,
  hubLabel,
  compact = false,
}: Props) {
  const { t } = useTranslation('marketing');
  const resolvedHubLabel = hubLabel ?? t(`${LP}.bookingBridge.hubLabel`);

  return (
    <section
      className={`booking-bridge-strip${compact ? ' booking-bridge-strip--compact' : ''}`}
      aria-labelledby="booking-bridge-title"
    >
      <div className="booking-bridge-strip__inner">
        {compact ? null : (
          <p className="booking-bridge-strip__eyebrow">{t(`${LP}.bookingBridge.eyebrow`)}</p>
        )}
        <h2 id="booking-bridge-title" className="booking-bridge-strip__title">
          {t(`${LP}.bookingBridge.title`)}
        </h2>
        {compact ? null : (
          <p className="booking-bridge-strip__body">
            {t(`${LP}.bookingBridge.bodyBeforeLink`)}{' '}
            <a href={BOOKING_HOME} rel="noopener noreferrer">
              rintintin-booking.com
            </a>{' '}
            {t(`${LP}.bookingBridge.bodyAfterLink`)}
          </p>
        )}
        <div className="booking-bridge-strip__actions">
          <a className="booking-bridge-strip__cta" href={BOOKING_HOME} rel="noopener noreferrer">
            {t(`${LP}.bookingBridge.cta`)}
          </a>
          {hubHref ? (
            <a className="booking-bridge-strip__link" href={hubHref} rel="noopener noreferrer">
              {resolvedHubLabel}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
